import { StyledSegmented } from 'components/new-ui/base/segmented/styles';

export type ArchiveFilterValue = 'active' | 'archived';

interface Props {
    value: ArchiveFilterValue;
    onChange: (value: ArchiveFilterValue) => void;
}

const ArchiveFilter = ({ value, onChange }: Props) => {
    return (
        <StyledSegmented
            options={[
                { value: 'active', label: 'Active' },
                { value: 'archived', label: 'Archived' },
            ]}
            value={value}
            onChange={onChange as (value: string | number) => void}
        />
    );
};

export default ArchiveFilter;
